import {Contrat} from "@/ts/contrat";
import {FournisseurBonus, KpiAvancement, KpiEnCours} from "@/ts/kpi";

import {getValeurBonusUnite} from "./getValeurBonusUnite";

export function calculePourcentage(valeur?: number, objectif?: number): number {
  if (
    typeof valeur === "number" &&
    typeof objectif === "number" &&
    objectif !== 0
  ) {
    return Math.round((valeur / objectif) * 100);
  }

  return NaN;
}

export function getAvancement(
  contrat: Contrat,
  bonus: FournisseurBonus
): KpiAvancement | undefined {
  if (contrat.statut === "actif" || contrat.statut === "cloture") {
    let nbObjectifValide: number = 0;
    let nbObjectifInProgress: number = 0;
    let nbObjectifForPalier: number = 0;
    let currentBonus: number = 0;
    // permet de garder en mémoir l'index du bonus au quelle à le droit l'adhérent
    // afin de pouvoir trouver le prochain palier.
    let indexNextBonus: number = 0;

    const kpis = contrat.campagne.kpis as KpiEnCours[];
    kpis
      ?.filter(kpi => kpi.objectif > 0)
      .forEach(elementKpi => {
        if (elementKpi.objectif <= elementKpi.valeur) {
          nbObjectifValide += 1;
        } else {
          nbObjectifInProgress += 1;
        }
      });
    bonus.paliers.sort((a, b) => a.seuil - b.seuil);
    bonus.paliers.forEach((bonusInArray, index) => {
      if (bonusInArray.seuil <= nbObjectifValide) {
        currentBonus = bonusInArray.valeur;
        indexNextBonus = index;
      }
    });
    if (bonus.paliers[indexNextBonus]) {
      nbObjectifForPalier =
        bonus.paliers[indexNextBonus].seuil - nbObjectifValide;
    }
    return {
      nb_objectif_valide: nbObjectifValide,
      nb_objectif_for_palier: nbObjectifForPalier,
      nb_objectif_inProgress: nbObjectifInProgress,
      current_bonus: currentBonus,
      current_bonus_unit: getValeurBonusUnite(
        bonus.type as "pourcentage-ca" | "fixe"
      ),
    };
  }
}
